import script from "./CoachingDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CoachingDetails.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__